import { Space } from 'component/Space'
import { ShopLogo } from 'feature/page/ShopLogo/ShopLogo'
import { observer } from 'mobx-react-lite'
import { ManagerButton } from 'page/catalog/BoutiqueHeader/ManagerButton'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { ui } from 'store/home/ui/HomeUiStore'

export const LeftPane = observer(() => {
  const { small } = ui.window
  const demo = useDemo()
  const { logo, logoUrl } = demo.product
  const client = !!employee.user && !small

  return <Space gap={8} flex="1" opposite={!client} oh>
    <ShopLogo logo={logo} link={logoUrl} />
    <ManagerButton />
  </Space>
})
